import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import { media } from '../../helpers/styleConstants';
import Typography from 'rmwc/Typography';
import Icon from 'rmwc/Icon';
import NumericScore from './NumericScore';
import LetterScoreThree from './LetterScoreThree';
import { Subscores } from './Subscores';
import { Money } from '../Money';
import {
  Dialog,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop,
} from 'rmwc/Dialog';
import { LegalNotices } from '../../components/LegalNotices';
import ResetOnboarding from '../../containers/Onboarding/ResetOnboarding';
import { wlPath } from '../../helpers/whitelabel';

const PlanImpact = ({ primary, secondaryLeft, secondaryRight }) => (
  <div className="plan-impact-chart" style={{ background: 'white' }}>
    <div className="primaryHolder">
      <Typography tag="div" use="subtitle1">
        <strong>Plan Impact</strong>
      </Typography>
      <Typography tag="div" use="body1">
        {primary.title}
      </Typography>
      <div className="primary">{primary.score}</div>
    </div>
    <div className="secondaryHolder">
      <div className="secondaryLeft">
        <Typography use="body1">{secondaryLeft.title}</Typography>
      </div>
      <div className="divider" />
      <div className="secondaryRight">
        <Typography use="body1">{secondaryRight.title}</Typography>
      </div>
    </div>
    <div className="secondaryHolder">
      <div className="secondaryLeft">{secondaryLeft.score}</div>
      <div className="divider" />
      <div className="secondaryRight">{secondaryRight.score}</div>
    </div>
  </div>
);

export default PlanImpact;

export const PlanImpactSecondary = ({ title, initialValue, updateValue, format }) => (
  <div className="plan-impact-chart mdc-elevation--z2" style={{ width: '125px', borderColor: '#10CF9B' }}>
    <div className="secondaryHolder" style={{ borderTop: 'none', height: '61px' }}>
      <div className="secondaryLeft">
        <Typography use="body1">{title}</Typography>
      </div>
    </div>
    <div className="secondaryHolder">
      <div className="secondaryLeft">
        <NumericScore initialValue={initialValue} updateValue={updateValue} format={format} />
      </div>
    </div>
  </div>
);

const SingleLegend = ({ chartClass, value, title, backgroundColor = '#fff' }) => (
  <div
    style={{
      borderTop: '1px solid #e0e0e0',
      backgroundColor: backgroundColor,
      textAlign: 'center',
      padding: '0.75rem 0.5rem',
    }}
  >
    <Typography
      use="subtitle1"
      tag="div"
      className="mb-1"
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <div className={chartClass} style={{ height: '20px', width: '20px', marginRight: '8px' }} />
      {title}
    </Typography>
    <div style={{ fontSize: '30px', color: value < 0 ? 'red' : value > 0 ? '#00B050' : 'inherit' }}>
      {value <= 0 ? '' : '+'}
      <Money amount={value} round={-3} />
    </div>
  </div>
);

export class PlanImpactSingle extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      healthCurrent,
      healthSingle,
      healthTotal,
      dollarsGainedSingle,
      dollarsGainedTotal,
      totalIsSingle,
      hideTotal,
      activeLabel,
      showHow,
      scores,
    } = this.props;

    return (
      <div className="plan-impact-chart" style={{ margin: '0 auto', background: 'white' }}>
        <div className="primaryHolder">
          <Typography tag="div" className="mt-1" use="subtitle1">
            <strong>Financial Health Score</strong>
          </Typography>
          <div className="primary">
            <LetterScoreThree
              initialValue={healthCurrent}
              singleBenefit={healthSingle || healthCurrent}
              totalBenefit={healthTotal || healthCurrent}
            />
          </div>
        </div>
        {!dollarsGainedSingle === false &&
          !totalIsSingle && (
            <SingleLegend
              chartClass={
                dollarsGainedSingle > 0
                  ? 'greenFillChange'
                  : dollarsGainedSingle == 0 ? 'empty-background' : 'redFillChange'
              }
              value={dollarsGainedSingle}
              title={`Potential Value of ${activeLabel}`}
              backgroundColor="#E0F3FF"
            />
          )}
        {!hideTotal && (
          <SingleLegend
            chartClass={
              !totalIsSingle ? 'total-background' : dollarsGainedTotal > 0 ? 'greenFillChange' : 'redFillChange'
            }
            value={dollarsGainedTotal}
            title="Improvement Potential"
          />
        )}
      </div>
    );
  }
}

const LegendWrapper = styled.div`
  padding: 0 0.5rem;
  margin-bottom: ${props => (props.small ? '0.5rem' : '1rem')};
  width: ${props => (props.small ? '185px' : '250px')};
  text-align: ${props => (props.small ? 'center' : 'center')};

  ${media.tabletPortraitUp`
    width: 250px;
    margin-bottom: 1rem;
  `};

  ${media.tabletLandscapeUp`
    text-align: center;
  `};
`;

const LabelShrink = styled.span`
  ${media.phoneOnly`
    font-size: ${props => (props.small ? '87.5%' : '100%')};
  `};
`;

const LegendValue = styled.div`
  margin-top: ${props => (props.small ? '0.375rem' : '0.5rem')};
  font-size: ${props => (props.small ? '20px' : '30px')};
  margin-left: ${props => (props.small ? '20px' : '0')};

  ${media.tabletPortraitUp`
    font-size: 30px;
  `};

  ${media.tabletLandscapeUp`
    line-height: 1;
    font-size: 30px;
    margin-top: 0.5rem;
    margin-left: 0px;
  `};
`;

const LabelIndicator = styled.div`
  height: 16px;
  width: 16px;
  margin-right: 4px;
  flex-shrink: 0;
`;

const LabelWrapper = styled.div`
  display: flex;
  justify-content: ${props => (props.small ? 'center' : 'center')};
  align-items: flex-start;

  ${media.tabletLandscapeUp`    
    justify-content: center;
  `};
`;

const SingleLegendNoFrame = ({ chartClass, value, title, small }) => (
  <LegendWrapper small={small}>
    <LabelWrapper small={small}>
      <LabelIndicator small={small} className={chartClass} />
      <Typography use="subtitle1" tag="div" style={{ lineHeight: '1.15' }}>
        <LabelShrink small={small}>{title}</LabelShrink>
      </Typography>
    </LabelWrapper>
    <LegendValue small={small} style={{ color: value < 0 ? 'red' : value > 0 ? '#00B050' : 'inherit' }}>
      {value <= 0 ? '' : '+'}
      <Money amount={value} round={-3} />
    </LegendValue>
  </LegendWrapper>
);

const LetterSizeContainer = styled.div`
  width: ${props => (props.smallOverride ? '135px' : '250px')};

  ${media.phoneOnly`
    width: ${props => (props.small ? '135px' : '250px')};
  `};
`;

export class PlanImpactSingleNoFrame extends Component {
  render() {
    const {
      healthCurrent,
      healthSingle,
      healthTotal,
      dollarsGainedSingle,
      dollarsGainedTotal,
      totalIsSingle,
      hideTotal,
      activeLabel,
      showHow,
      scores,
    } = this.props;

    return (
      <div>
        <LetterSizeContainer small={this.props.small}>
          <LetterScoreThree
            initialValue={healthCurrent}
            singleBenefit={healthSingle || healthCurrent}
            totalBenefit={healthTotal || healthCurrent}
          />
        </LetterSizeContainer>
        {!dollarsGainedSingle === false &&
          !totalIsSingle && (
            <SingleLegendNoFrame
              chartClass={
                dollarsGainedSingle > 0
                  ? 'greenFillChange'
                  : dollarsGainedSingle == 0 ? 'empty-background' : 'redFillChange'
              }
              value={dollarsGainedSingle}
              title={`Potential Value of ${activeLabel}`}
              backgroundColor="#E0F3FF"
            />
          )}
        {!hideTotal && (
          <SingleLegendNoFrame
            chartClass={
              !totalIsSingle ? 'total-background' : dollarsGainedTotal > 0 ? 'greenFillChange' : 'redFillChange'
            }
            value={dollarsGainedTotal}
            title="Improvement Potential"
          />
        )}
      </div>
    );
  }
}

const AppImpactContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media.tabletLandscapeUp`
    flex-direction: column;
    align-items: center;
  `};
`;

const LegendContainer = styled.div`
  display: flex;
  padding-top: 0.5rem;
  flex-direction: column;

  ${media.tabletPortraitUp`
    padding-top: 0.75rem;
  `};

  ${media.tabletLandscapeUp`
    padding-top: 0;
  `};
`;

export class PlanImpactApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      howDialogOpen: false,
    };
  }

  render() {
    const {
      healthCurrent,
      healthSingle,
      healthTotal,
      dollarsGainedSingle,
      dollarsGainedTotal,
      totalIsSingle,
      hideTotal,
      activeLabel,
      showHow,
      scores,
    } = this.props;

    return (
      <AppImpactContainer>
        <LetterSizeContainer small={this.props.small}>
          <LetterScoreThree
            initialValue={healthCurrent}
            singleBenefit={healthSingle || healthCurrent}
            totalBenefit={healthTotal || healthCurrent}
          />
        </LetterSizeContainer>
        <LegendContainer>
          {!dollarsGainedSingle === false &&
            !totalIsSingle && (
              <div>
                <SingleLegendNoFrame
                  chartClass={
                    dollarsGainedSingle > 0
                      ? 'greenFillChange'
                      : dollarsGainedSingle == 0 ? 'empty-background' : 'redFillChange'
                  }
                  value={dollarsGainedSingle}
                  title={`Potential Value of ${activeLabel}`}
                  backgroundColor="#E0F3FF"
                  small={this.props.small}
                />
                <div class="text-center mb-3" style={{ marginTop: '-0.5rem' }}>
                  <a href={wlPath('/action-plan-value')} target="_blank">See Calculation</a>
                </div>
              </div>
            )}
          {!hideTotal && (
            <SingleLegendNoFrame
              chartClass={
                !totalIsSingle ? 'total-background' : dollarsGainedTotal > 0 ? 'greenFillChange' : 'redFillChange'
              }
              value={dollarsGainedTotal}
              title="Improvement Potential"
              small={this.props.small}
            />
          )}
          <div style={{ textAlign: 'center', marginTop: '-0.5rem' }}>
            <a href="#" onClick={() => this.setState({ howDialogOpen: true })}>
              How did you get this score?
            </a>
          </div>
          <div style={{ textAlign: 'center' }}>
            <LegalNotices />
          </div>
          <div className="d-none">
            <div style={{ margin: '10px auto 0' }}>
              <ResetOnboarding />
            </div>
          </div>
        </LegendContainer>
        <Dialog open={this.state.howDialogOpen} onClose={evt => this.setState({ howDialogOpen: false })}>
          <DialogSurface>
            <DialogBody scrollable style={{ minHeight: '400px', marginTop: '0px' }}>
              <Subscores scores={scores} ref={node => (this.howScore = node)} />
            </DialogBody>
            <DialogFooter>
              <DialogFooterButton onClick={evt => this.setState({ howDialogOpen: false })} accept>
                Back
              </DialogFooterButton>
            </DialogFooter>
          </DialogSurface>
          <DialogBackdrop />
        </Dialog>
      </AppImpactContainer>
    );
  }
}

export class PlanImpactAppSmall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      howDialogOpen: false,
    };
  }

  render() {
    const {
      healthCurrent,
      healthSingle,
      healthTotal,
      dollarsGainedSingle,
      dollarsGainedTotal,
      totalIsSingle,
      hideTotal,
      activeLabel,
      showHow,
      scores,
    } = this.props;

    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          backgroundColor: 'white',
          boxShadow:
            '0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12)',
        }}
      >
        <LetterSizeContainer smallOverride small={this.props.small}>
          <LetterScoreThree
            initialValue={healthCurrent}
            singleBenefit={healthSingle || healthCurrent}
            totalBenefit={healthTotal || healthCurrent}
          />
        </LetterSizeContainer>
        <div className="mt-1">
          {!dollarsGainedSingle === false &&
            !totalIsSingle && (
              <div>
                <SingleLegendNoFrame
                  chartClass={
                    dollarsGainedSingle > 0
                      ? 'greenFillChange'
                      : dollarsGainedSingle == 0 ? 'empty-background' : 'redFillChange'
                  }
                  value={dollarsGainedSingle}
                  title={`Potential Value of ${activeLabel}`}
                  backgroundColor="#E0F3FF"
                  small={this.props.small}
                />
                <div class="text-center mb-1" style={{ fontSize: '87.5%', marginTop: '-0.25rem' }}>
                  <a href={wlPath('/action-plan-value')} target="_blank">See Calculation</a>
                </div>
              </div>
            )}
          {!hideTotal && (
            <SingleLegendNoFrame
              chartClass={
                !totalIsSingle ? 'total-background' : dollarsGainedTotal > 0 ? 'greenFillChange' : 'redFillChange'
              }
              value={dollarsGainedTotal}
              title="Improvement Potential"
              small={this.props.small}
            />
          )}
          <div className="text-center mb-1"  style={{ fontSize: '87.5%', marginTop: '-0.25rem' }}>
            <a href="#" onClick={() => this.setState({ howDialogOpen: true })}>
              How did you get this score?
            </a>
          </div>
        </div>
        <Dialog open={this.state.howDialogOpen} onClose={evt => this.setState({ howDialogOpen: false })}>
          <DialogSurface>
            <DialogBody scrollable style={{ minHeight: '400px', marginTop: '0px' }}>
              <Subscores scores={scores} ref={node => (this.howScore = node)} />
            </DialogBody>
            <DialogFooter>
              <DialogFooterButton onClick={evt => this.setState({ howDialogOpen: false })} accept>
                Back
              </DialogFooterButton>
            </DialogFooter>
          </DialogSurface>
          <DialogBackdrop />
        </Dialog>
      </div>
    );
  }
}
